// shared-imports.ts
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

// PrimeNG imports
import { ButtonModule } from 'primeng/button';
import { TableModule } from 'primeng/table';
import { AnimateOnScrollModule } from 'primeng/animateonscroll';
import { SelectModule } from 'primeng/select';
import { GalleriaModule } from 'primeng/galleria';
import { InputTextModule } from 'primeng/inputtext';
import { InputOtpModule } from 'primeng/inputotp';
// ...add other PrimeNG or Angular stuff you use frequently
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { MegaMenuModule } from 'primeng/megamenu';
import { StepperModule } from 'primeng/stepper';
import { RadioButtonModule } from 'primeng/radiobutton';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { PaginatorModule } from 'primeng/paginator';

import { MenubarModule } from 'primeng/menubar';
import { CheckboxModule } from 'primeng/checkbox';
import { PasswordModule } from 'primeng/password';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { InputGroupModule } from 'primeng/inputgroup';
import { DatePickerModule } from 'primeng/datepicker';
import { MultiSelectModule } from 'primeng/multiselect';
import { FileUploadModule } from 'primeng/fileupload';
import { TextareaModule } from 'primeng/textarea';
import { TreeTableModule } from 'primeng/treetable';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DialogModule } from 'primeng/dialog';
import { DrawerModule } from 'primeng/drawer';
import { StyleClass } from 'primeng/styleclass';
import { PanelModule } from 'primeng/panel';
import { AccordionModule } from 'primeng/accordion';
import { TabsModule } from 'primeng/tabs';
import { Toast } from 'primeng/toast';
import { ToastModule } from 'primeng/toast';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { TooltipModule } from 'primeng/tooltip';
import { SkeletonModule } from 'primeng/skeleton';
import { Skeleton } from 'primeng/skeleton';
import { TagModule } from 'primeng/tag';
import { ImageCropperComponent } from 'ngx-image-cropper';
import { EditorModule } from 'primeng/editor';
import { TreeModule } from 'primeng/tree';
import { CardModule } from 'primeng/card';
import { ChipModule } from 'primeng/chip';
export const SHARED_IMPORTS = [
  CommonModule,
  FormsModule,
  ReactiveFormsModule,
  TableModule,
  AnimateOnScrollModule,
  SelectModule,
  ButtonModule,
  GalleriaModule,
  ToggleSwitchModule,
  MegaMenuModule,
  StepperModule,
  RadioButtonModule,
  BreadcrumbModule,
  InputTextModule,
  InputOtpModule,
  MenubarModule,
  PaginatorModule,
  MenubarModule,
  CheckboxModule,
  PasswordModule,
  InputGroupAddonModule,
  InputGroupModule,
  DatePickerModule,
  MultiSelectModule,
  FileUploadModule,
  TextareaModule,
  TreeTableModule,
  DialogModule,
  ConfirmDialogModule,
  DrawerModule,
  StyleClass,
  PanelModule,
  AccordionModule,
  TabsModule,
  Toast,
  ToastModule,
  ConfirmPopupModule,
  TooltipModule,
  SkeletonModule,
  Skeleton,
  TagModule,
  ImageCropperComponent,
  EditorModule,
  TreeModule,
  CardModule,
  ChipModule
];
